import React, { Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import { PageAnimation } from '../../Layout/Components/Animation';
import PageTitle from '../../Layout/Components/PageTitle';
import Strings from '../../translations/Translations';
import ManageCampaignModule from '../../modules/campaign/manage/ManageCampaignModule';

export default function Manage() {
  return (
    <Fragment>
      <PageAnimation>
        <PageTitle
          heading={Strings('videos')}
          subheading=""
          icon="pe-7s-video"
        />

        <Row className="mb-4">
          <Col>
            <ManageCampaignModule />
          </Col>
        </Row>
      </PageAnimation>
    </Fragment>
  );
}
